import { Card, Spinner } from "react-bootstrap";
import Icon from "@mdi/react";
import { mdiChevronRight } from "@mdi/js";
import { ReactNode } from "react";

type DashboardCardProps = {
	title: string;
	subtitle?: string;
	icon: string;
	iconClass?: string;
	value?: string;
	valueDescription?: string | ReactNode;
	footer?: string | ReactNode;
	loading?: boolean;
	onClick?: () => void;
};

export default function DashboardCard(props: DashboardCardProps) {
	return (
		<Card className="border-0 shadow p-4" onClick={props.onClick} style={{ cursor: props.onClick ? "pointer" : "" }}>
			<div className={`d-flex align-items-center line-1 small ${props.loading && "skeleton skeleton-text skeleton-text-title"}`}>{props.title}</div>
			<Card.Body className="d-flex flex-row justify-content-between gap-2 p-0">
				<div className="d-flex flex-column flex-fill">
					<div className={`d-flex align-items-center`} style={{ minHeight: 60 }}>
						{props.loading ? (
							<Spinner className="fs-6" />
						) : (
							<>
								<div className="fw-bold fs-1">{props.value}</div>
								{props.valueDescription}
							</>
						)}
					</div>
					{props.subtitle && (
						<div className={`d-flex align-items-center line-1 fw-light text-muted small ${props.loading && "skeleton skeleton-text skeleton-text-title"}`}>{props.subtitle}</div>
					)}
				</div>
				<div className="d-flex flex-row align-items-center justify-content-center">
					<Icon path={props.icon} className={`${props.iconClass}`} style={{ width: 60 }} />
					{props.onClick && <Icon path={mdiChevronRight} size={1} className={`text-muted`} style={{ marginRight: -12 }} />}
				</div>
			</Card.Body>
			{props.footer && <Card.Footer className={`bg-white p-0 border-0 fw-light small text-muted ${props.loading && "skeleton skeleton-text skeleton-text-title"}`}>{props.footer}</Card.Footer>}
		</Card>
	);
}
